import { useState, useEffect } from 'react';
import { getStoredPairs } from '../utils/pairing';
import { getPairingConfirmed } from '../services/pairingConfirm';

/**
 * True when we have exactly one local and one remote pair and that pairing
 * is confirmed (both devices signed, stored in IndexedDB).
 */
export function usePairingConnected(): {
  connected: boolean;
  loading: boolean;
} {
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function check(): Promise<void> {
      const pairs = getStoredPairs();
      const local = pairs.find((p) => p.is_local);
      const remote = pairs.find((p) => !p.is_local);
      if (local === undefined || remote === undefined) {
        if (!cancelled) {
          setConnected(false);
          setLoading(false);
        }
        return;
      }
      try {
        const ok = await getPairingConfirmed(local.uuid, remote.uuid);
        if (!cancelled) {
          setConnected(ok);
        }
      } catch {
        if (!cancelled) {
          setConnected(false);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    void check();
    return () => {
      cancelled = true;
    };
  }, []);

  return { connected, loading };
}
